<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">课题征集&gt;</div>
      </div>
      <div class="body_content">
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content query-modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h4 class="modal-title" id="myModalLabel">{{optionFlag=="add"?'新增':'修改'}}课题反馈</h4>
              </div>
              <div class="modal-body query-modal-lesson">
                <label>标题：</label>
                <input type="text" v-validate="'required|maxL:100'" data-vv-scope="feedback" data-vv-as="标题" name="subTitle"  placeholder="输入标题" class="form-control lesson_name" v-model="feedback.subTitle"/>
                <span class="spanRed">*</span>
                <span class="validateTip">{{ errors.first('feedback.subTitle') }}</span>

                <label>科室：</label>
                <input type="text" v-validate="'maxL:100'" data-vv-scope="dept" data-vv-as="标题" name="dept"  placeholder="输入科室" class="form-control lesson_name" v-model="feedback.dept"/>
                <span class="spanRed"></span>
                <span class="validateTip">{{ errors.first('feedback.dept') }}</span>

                <label>描述：</label>
                <textarea class="form-control description-textarea" v-validate="'maxL:200'" data-vv-scope="feedback" data-vv-as="描述" placeholder="描述" rows="10" name="subDes" v-model="feedback.subDes" style="resize: none"></textarea>
                <span class="spanRed"></span>
                <span class="validateTip">{{ errors.first('feedback.subDes') }}</span>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default" @click="saveData()">确定</button>
                <button type="button" class="btn btn-default" data-dismiss="modal" @click="">取消</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="myViewModal" tabindex="-1" role="dialog" aria-labelledby="myViewModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content query-modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h4 class="modal-title" id="myModalLabel">课题反馈详情</h4>
              </div>
              <div class="modal-body query-modal-lesson">

                <div class="form-group-div">
                  <div class="form-group">
                    <label class="unit_content_label_name">标题：</label>{{feedback.title}}
                  </div>
                  <div class="form-group">
                    <label class="unit_content_label_name">描述：</label>{{feedback.des}}
                  </div>
                  <div class="form-group">
                    <label class="unit_content_label_name">截止时间：</label>{{feedback.deadLine}}
                  </div>
                  <div class="form-group">
                    <label class="unit_content_label_name">我的课题反馈：</label>{{feedback.subTitle}}
                  </div>
                  <div class="form-group">
                    <label class="unit_content_label_name">科室：</label>{{feedback.dept}}
                  </div>
                  <div class="form-group">
                    <label class="unit_content_label_name">课题反馈描述：</label>{{feedback.subDes}}
                  </div>
                  <div class="form-group">
                    <label class="unit_content_label_name">反馈提交时间：</label>{{feedback.createDate}}
                  </div>
                </div>

              </div>

              <div class="modal-footer">
                <!--                <button type="button" class="btn btn-default okBtn" @click="addLesson()">确定</button>-->
                <!--                <button type="button" class="btn btn-default okBtn" data-dismiss="modal" @click="">取消</button>-->
              </div>
            </div>
          </div>
        </div>
        <div class="classList_div">
          <!--          <div class="searcharea">-->
          <!--            <label style="margin: 10px 0 10px 5px;">时间筛选:</label>-->
          <!--            <input id="startDate" data-vv-as="开始日期" class="form-control new_date" size="16" type="text" name="startDate" readonly v-model="searchParams.startDate"/>-->
          <!--            <span class="spanRed"></span>-->
          <!--            ——-->
          <!--            <input id="endDate" data-vv-as="结束日期" class="form-control new_date" size="16" type="text" name="endDate" readonly v-model="searchParams.endDate"/>-->
          <!--            <input class="form-control" placeholder="请输入班级名称"  v-model="searchParams.name"/>-->
          <!--            <button type="button" class="btn btn-default btn_option" @click="searchParams.page==1;searchParams.rows=10;pageClick()">查询</button>-->
          <!--            <button type="button" class="btn btn-default" @click="refresh()">重置</button>-->
          <!--          </div>-->
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th width="20%">标题</th>
              <th width="20%">描述</th>
              <th width="10%">截止时间</th>
              <th width="20%">我的课题反馈</th>
              <th width="10%">提交时间</th>
              <th width="15%">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(collectionOne, index) in dataList" :key="index">
              <td width="20%">{{collectionOne.title}}</td>
              <td width="20%">{{collectionOne.des}}</td>
              <td width="10%">{{collectionOne.deadLine}}</td>
              <td width="20%">
                {{collectionOne.subTitle}}
              </td>
              <td width="10%">
                {{collectionOne.createDate}}
              </td>
              <td width="15%"><!--:class="{show_edit_pic: collectionOne.checkStatus == 0}"-->
                <a href="#" @click="optionFlag='add';add(collectionOne)"
                   v-if="new Date() <= new Date(collectionOne.deadLine + ' 23:59:59')">反馈</a>
                <template v-if="collectionOne.id">
                  <a href="#" @click="optionFlag='edit';update(collectionOne)">修改</a>
                  <a href="#" @click="deleteData(collectionOne.id)">删除</a>
                </template>
                <a href="#" @click="getData(collectionOne)">查看</a>
              </td>
            </tr>
            </tbody>
          </table>
          <!--分页-->
          <page-view v-bind="searchParams"></page-view>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {schoolAxios} from '../main';
import {getContentSize} from './mainView';
import pageView from "./pageView";

export default {
  name: "researchFeedback",
  components:{pageView},
  data() {
    return {
      dataList: [],
      userCode: this.$store.state.userCode,
      searchParams: {
        title:'',
        all: 0,
        rows: 10,
        page:1
      },
      optionFlag:"",
      feedback: {
        id: '',
        subTitle: '',
        subDes: '',
        dept: '',
        crator: '',
        userId: '',
        createDate: '',
        collId: '',
        title: '',
        des: '',
        deadLine: '',
      }
    }
  },
  mounted: function () {
    let this_ = this;
    this.$nextTick(function () {
      getContentSize();
      this_.initData();
      this_.dateDefault();
      this_.searchParams.page = 1;
      this_.searchParams.pageCallback = this_.initData;
      // this_.getClassCountsByStatus();
    });
  },
  methods: {
    // dateDefault(){
    //   let this_ = this;
    //   let date, nowDate;
    //   date = new Date();
    //   nowDate = date.getFullYear() + "-";
    //   nowDate += (date.getMonth() + 1) + "-";
    //   nowDate += date.getDate() + " ";
    //   this_.timeDate = nowDate;
    //   $('#deadLine').datetimepicker({
    //     minView: "month",//选择日期后，不会再跳转去选择时分秒
    //     language: 'zh-CN',
    //     format: 'yyyy-mm-dd',
    //     //startDate: this_.timeDate,
    //     weekStart: 0,
    //     todayBtn: true,
    //     clearBtn: true,
    //     autoclose: true,//选择一个日期后是否立即关闭此选择框
    //     todayHighlight: true,//高亮当前日期
    //     startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
    //     forceParse: 0,
    //     showMeridian: 1,
    //   }).on('hide', function (ev) {
    //     let value = $("#deadLine").val();
    //     this_.feedback.deadLine = value;
    //
    //     ev.preventDefault();
    //     ev.stopPropagation();
    //   });
    // },
    initData(pageParams){
      let this_ = this;
      if(pageParams)
        Object.assign(this_.searchParams, pageParams);

      let _searchParams = {};
      Object.assign(_searchParams, this_.searchParams);
      delete _searchParams.pageCallback;//提交前删除回调
      console.log(_searchParams)
      schoolAxios({
        method: 'get',
        url: 'researchFeedback/findPage',
        params:_searchParams
      }).then(function (response) {
        console.info(response);
        let data = response.data;
        if (data.success) {
          this_.dataList = data.list;
          this_.searchParams.all = data.totalPage;
          this_.searchParams.page = 1;
        }
      });
    },
    pageClick(){
      let this_=this;
      //console.log('现在是'+this.cur+'页');
      this_.initClassData();
    },
    pageSkip(){
      var maxPage = this.searchParams.all;
      var skipPage = Number(document.getElementsByClassName("jumppage")[0].value);
      //console.log(typeof skipPage);
      if(!skipPage){
        alert("请输入跳转页码");
        return;
      }else if(skipPage<1 || skipPage>maxPage){
        alert("您输入的页码超过页数范围了！");
        return;
      }else{
        this.searchParams.page=skipPage;
        // this.btnClick(skipPage);
        this.pageClick();
      }
    },
    update(collectionOne){
      let this_ = this;

      this_.feedback = {
        id: collectionOne.id,
        title: collectionOne.title,
        des: collectionOne.des,
        crator: collectionOne.crator,
        status: collectionOne.status,
        deadLine:collectionOne.deadLine,
        subTitle: collectionOne.subTitle,
        subDes: collectionOne.subDes,
        dept: collectionOne.dept,
        userId: collectionOne.userId,
        createDate: collectionOne.createDate,
        collId: collectionOne.collId,
      };

      $("#myModal").modal('show');
      setTimeout(function () {
        this_.errors.clear('feedback');
      });
    },
    updateData(){
      let this_=this;
      console.log('----------------updateData:',this_.feedback)
      this_.$validator.validateAll('feedback').then(result => {
        if (result) {
          schoolAxios({
            method: 'put',
            url: 'researchFeedback/edit',
            params: this_.feedback
            // {
            //     "id":collectionOne.id,
            //     "title":collectionOne.title,
            //     "des":collectionOne.des,
            //     "deadLine":collectionOne.deadLine,
            //   }
          }).then(function (response) {
            let data = response.data;
            if (data.success) {
              $("#myModal").modal("hide");
              setTimeout(function () {
                this_.errors.clear('feedback');
              });
              this_.initData();
            }
          });
        }
      })
    },
    deleteData(id){
      let this_ = this;
      //执行删除
      "确定是否删除".showConfirm(function () {
        schoolAxios({
          method: 'delete',
          url: 'researchFeedback/delete/'+id,
          params: {}
        }).then(function (response) {
          console.info(response);
          let data = response.data;
          if(data.success){
            this_.initData();
          }
        });
      })
    },
    add(collectionOne){
      let this_=this;
      Object.keys(this_.feedback).forEach(i=>{
        this_.feedback[i] = ''
      })
      this_.feedback.collId = collectionOne.collId
      $("#myModal").modal("show");
      setTimeout(function () {
        this_.errors.clear('feedback');
      });
    },
    addData(){
      let this_ = this;
      console.log('------------this_.feedback:',this_.feedback)
      this_.$validator.validateAll('feedback').then(result => {
        if (result) {
      schoolAxios({
        method: 'post',
        url: 'researchFeedback/add',
        data: this_.feedback
      }).then(function (resp) {
        let data = resp.data;
        if(data.success){
          $("#myModal").modal("hide");
          // "保存成功".showMessage();
          setTimeout(function () {
            this_.errors.clear('feedback');
          });
          this_.initData();
        }else{
          (data.message||"保存失败").showMessage();
        }
      })
        }
      });
    },
    saveData(){
      let this_ = this;
      if(this_.optionFlag == 'add'){
        this_.addData();
      }else {
        this_.updateData();
      }
    },
    getData(collectionOne){
      let this_ = this;

      this_.feedback = {
        id: collectionOne.id,
        title: collectionOne.title,
        des: collectionOne.des,
        crator: collectionOne.crator,
        status: collectionOne.status,
        deadLine:collectionOne.deadLine,
        subTitle: collectionOne.subTitle,
        subDes: collectionOne.subDes,
        dept: collectionOne.dept,
        userId: collectionOne.userId,
        createDate: collectionOne.createDate,
        collId: collectionOne.collId,
      };

      $("#myViewModal").modal('show');

    },
    dateDefault(){
      let this_ = this;
      let date, nowDate;
      date = new Date();
      nowDate = date.getFullYear() + "-";
      nowDate += (date.getMonth() + 1) + "-";
      nowDate += date.getDate() + " ";
      this_.timeDate = nowDate;
      $('#deadLine').datetimepicker({
        minView: "month",//选择日期后，不会再跳转去选择时分秒
        language: 'zh-CN',
        format: 'yyyy-mm-dd',
        //startDate: this_.timeDate,
        weekStart: 0,
        todayBtn: true,
        clearBtn: true,
        autoclose: true,//选择一个日期后是否立即关闭此选择框
        todayHighlight: true,//高亮当前日期
        startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
        forceParse: 0,
        showMeridian: 1,
      }).on('hide', function (ev) {
        let value = $("#deadLine").val();
        this_.feedback.deadLine = value;

        ev.preventDefault();
        ev.stopPropagation();
      });
      $('#createDate').datetimepicker({
        minView: "month",//选择日期后，不会再跳转去选择时分秒
        language: 'zh-CN',
        format: 'yyyy-mm-dd',
        //startDate: this_.timeDate,
        weekStart: 0,
        todayBtn: true,
        clearBtn: true,
        autoclose: true,//选择一个日期后是否立即关闭此选择框
        todayHighlight: true,//高亮当前日期
        startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
        forceParse: 0,
        showMeridian: 1,
      }).on('hide', function (ev) {
        let value = $("#createDate").val();
        this_.feedback.createDate = value;

        ev.preventDefault();
        ev.stopPropagation();
      });
    },
  },
  computed: {
    indexs(){
      var left = 1;
      var right = this.searchParams.all;
      var arr = [];
      if(this.searchParams.all>=7){
        if(this.searchParams.page>4 && this.searchParams.page<this.searchParams.all-3){
          left = this.searchParams.page-3;
          right = this.searchParams.page+3;
        }else if(this.searchParams.page<=4){
          left=1;
          right=7;
        }else{
          left=this.searchParams.all-6;
          right=this.searchParams.all;
        }
      }
      while(left<=right){
        arr.push(left);
        left++;
      }
      return arr;
    }
  }
}
</script>

<style scoped>
@import '../assets/css/plugins.css';
@import "../assets/css/publicStyle.css";

.situation_one_div span {
  font-size: 45px;
  font-weight: bold;
}
.situation_one_div div {
  float: right;
  width: 25%;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0.6;
}
.classList_div {
  position: relative;
  /*top: 2%;*/
  width: 100%;
  /*height: 86%;*/
  overflow: auto;
}

table tr{
  text-align: center;
}
table th {
  background: #cccccc;
  text-align: center;
}
.table-striped {
  /*background-color: #D7D7D7;*/
}
/*.table tbody{
  display: block;
  height: 640px;
  overflow: auto;
}*/

/*分页*/
#page-break {
  margin-top: 20px;
  margin-left: 30%;
}
#page-break li {
  list-style: none;
}
#page-break a {
  border: 1px solid #ddd;
  text-decoration: none;
  float: left;
  padding: 6px 12px;
  /*color: #337ab7;*/
  color: #d44950;
  cursor: pointer}
#page-break a:hover {
  background-color: #eee;
}
#page-break a .banclick {
  cursor: not-allowed;
}
#page-break .active a {
  color: #fff;
  cursor: default;
  /*background-color: #337ab7;
   border-color: #337ab7;*/
  background-color: #d44950;
  border-color: #ff6f66;
}
#page-break i {
  font-style: normal;
  color: #d44950;
  margin: 0px 4px;
  font-size: 12px;
}
#page-break .jumpbox .jumppage {
  border: 1px solid #ddd;
  margin-left: 40px;
  height: 33px;
  width: 40px;
  float: left;}
#page-break .jumpbox .jumpbtn {
  cursor: pointer;
  margin-left: 10px;
}
#page-break .jumpbox .jumpbtn:active {
  color: #d44950;
}
.dropdown-menu {
  min-width: 80px;
}
.dropdown-menu li {
  margin: 0 0 0 12%;
}
.dropdown-toggle {
  color: #d44950;
}
</style>



// WEBPACK FOOTER //
// src/components/researchFeedback.vue